const breakpoints = {
  desktop: 1750,
  tablet: 859,
  phone: 600,
};

/**
 * Получение процента ребенка относительно родителя
 * @param {Number}
 * @param {Number}
 * @return {Number}
 */

export function percent(parent, child) {
  return child * 100 / parent;
}

/**
 * Получение media query
 * @param {String} - один из ключей breakpoints
 * @param {String} - один из ключей breakpoints
 * @return {String}
 */

export function getMedia(from, to) {
  if (to !== undefined) {
 return `(max-width: ${breakpoints[from]}px) and (min-width: ${breakpoints[to] + 1}px)`;
}
  return `(max-width: ${breakpoints[from]}px)`;
}

/**
 * Получение media query min
 * @param {String} - один из ключей breakpoints
 * @return {String}
 */

export function getMediaMin(from) {
  return `(min-width: ${breakpoints[from] + 1}px)`;
}

/**
 * Получение текущего брекпоинта
 * @return {String}
 */

export function getCurrentBreakpoint() {
  const keys = Object.keys(breakpoints);
  let current = keys[0];

  try {
    keys.forEach((key) => {
      if (window.matchMedia(`(max-width: ${breakpoints[key]}px)`).matches) {
        current = key;
      }
    });

    return current;
  } catch (e) {
    return current;
  }
}
